import React, { useState, useEffect, useContext, useCallback } from 'react'

import axios from 'axios'

import { useAuth0 } from '../../auth0-wrapper'
import { useSelector } from 'react-redux'
import { getFilterValueByKey } from '../../redux/filters/reducer'

export const StoresContext = React.createContext()
export const useStores = () => useContext(StoresContext)

// Le chiavi degli oggetti qui sotto sono le Locations di Netsuite: https://4530851.app.netsuite.com/app/common/otherlists/locationlist.nl?whence= Quando viene aperto un nuovo store, visitare il link e prendere l'ID della Location principale su Netsuite e aggiungerlo qui.

// I giorni in cui devono essere consegnati i pacchi. 1 = lunedì, 2 = martedì, 3 = mercoledì, 4 = giovedì, 5 = venerdì
export const transferOrderDeliveryDays = {
  13: 5, // Roma Prati 93
  20: 1, // Torino Mazzini
  25: 4, // Campo Marzio 9, giovedì
  26: 1, // Archimede, lunedì
  28: 4, // Garibaldi, giovedì
  29: 2, // Firenze, martedì
  30: 3, // Bologna, mercoledì
  31: 5, // Parigi (OLD), venerdì
  32: false, // London (OLD), no giorno
  35: false, // NY (OLD) non dovrebbe esserci, ma deve esserci
  40: 2, // Palermo martedì
  48: false, // London, no giorno
  49: false, // NY Nolita, no giorno
  5: 1, // Sempione, lunedì
  50: 3, // Parigi Dragon, mercoledì
  52: 5, // Giovine Italia, venerdì
  53: 4, // Napoli, giovedì
  55: 5, // Brescia, venerdì
  57: 4, // Torino Carlo Alberto
  60: 4, // Campo Marzio 71
  61: 2, // Rinascente Milano
  63: 5, // Bottega Mercato
  64: false, // Rinascente Roma Fiume Uomo
  80: false, // Rinascente Roma Fiume Donna
  81: 1, // Rinascente Roma Tritone Uomo
  // 173: // Temporary Tortona
  193: 5, // Roma Prati 95
  206: 5, // Verona Sant'Astasia
  205: 5, // Padova Santa Lucia
  224: 5, // Franciacorta
  229: false, // NY Madison
  237: 3, // Copenhagen
  257: 5, // Forte dei Marmi
  244: 3, // Parigi Boissy
  249: 3, // Parigi Four
  265: 3, // Monaco
}

// I giorni in cui devono essere ritirati i pacchi dalla logistica. 1 = lunedì, 2 = martedì, 3 = mercoledì, 4 = giovedì, 5 = venerdì
export const transferOrderPickUpDays = {
  13: 3, // Roma Prati 93
  20: 4, // Torino
  25: 2, // Campo Marzio 9
  26: 4, // Archimede,
  28: 2, // Garibaldi
  29: 5, // Firenze
  30: 5, // Bologna
  31: 2, // Parigi (OLD)
  32: 5, // London (OLD)
  35: 5, // NY (OLD)
  40: 5, // Palermo
  48: 5, // London
  49: 5, // NY Nolita
  5: 4, // Sempione
  50: 4, // Parigi Dragon
  52: 3, // Giovine Italia
  53: 2, // Napoli
  55: 2, // Brescia
  57: 2, // Torino Carlo Alberto
  60: 2, // Campo Marzio 71
  61: 5, // Rinascente Milano
  63: 3, // Bottega Mercato
  64: 5, // Rinascente Roma Fiume Uomo
  80: 5, // Rinascente Roma Fiume Donna
  81: 5, // Rinascente Roma Tritone Uomo
  // 173: // Temporary Tortona
  193: 3, // Roma Prati 95
  206: 3, // Verona Sant'Astasia
  205: 3, // Padova Santa Lucia
  224: 2, // Franciacorta
  229: false, // NY Madison
  237: 4, // Copenhagen
  257: 3, // Forte dei Marmi
  244: 4, // Parigi Boissy
  249: 4, // Parigi Four
  265: 4, // Monaco
}

// L'orario di consegna dei pacchi
const transferOrderDeliveryTime = {
  13: '8.30-9.30', // Roma prati
  20: '11.00-13.00', // Torino
  25: '8.30-9.30', // Campo Marzio 9
  26: '10.30-11.30', // Archimede
  28: '8.30-9.30', // Garibaldi
  29: '11.00-13.00', // Firenze
  30: '10.00-12.00', // Bologna
  31: '8.30-9.30', // Parigi (OLD)
  32: false, // London (OLD), nessun giorno
  35: false, // NY non dovrebbe esserci, ma deve esserci
  40: 'in giornata', // Palermo
  48: false, // London, nessun giorno
  49: false, // NY Nolita
  5: '8.30-9.30', // Sempione
  50: '8.30-9.00', // Parigi Dragon
  52: '8.30-9.30', // Giovine Italia
  53: '10.00-10.30', // Napoli
  55: '10.00-12.00', // Brescia
  57: '11.00-13.00', // Torino Carlo Alberto
  60: '8.30-9.30', // Campo Marzio 71
  61: false, // Rinascente Milano
  63: '8.30-9.30', // Bottega Mercato
  64: false, // Rinascente Roma Fiume Uomo
  80: false, // Rinascente Roma Fiume Donna
  81: 'entro le 11.00', // Rinascente Roma Tritone Uomo
  // 173: // Temporary Tortona
  193: '8.30-9.30', // Roma Prati 95
  206: '9.00-9.30', // Verona Sant'Astasia
  205: '10.30-12.30', // Padova Santa Lucia
  224: '9.00-10.00', // Franciacorta
  229: false, // NY Madison
  237: false, // Copenhagen
  257: '8.30-9.30', // Forte dei Marmi
  244: '9.30-10.30', // Parigi Boissy
  249: '8.30-9.30', // Parigi Four
  265: '8.30-9.30', // Monaco
}

// Una nota aggiuntiva sulla consegna, stampata come frase a sé dopo la riga "Consegna ..."
const transferOrderDeliveryNote = {
  61: 'Consegna tassativa entro le 11.00.', // Rinascente Milano
  237: 'A negozio aperto.', // Copenhagen
}

// L'orario a cui devono essere ritirati i pacchi
const transferOrderPickUpTimes = {
  13: '10.30-11.00', // Roma Prati 93
  20: '10.30-11.00', // Torino Mazzini
  25: '10.30-11.00', // Campo Marzio 9
  26: '10.30-11.00', // Archimede
  28: '10.30-11.00', // Garibaldi
  29: '10.30-11.00', // Firenze
  30: '10.30-11.00', // Bologna
  31: '14.00-14.30', // Parigi (OLD)
  32: '14.00-14.30', // London (OLD), nessun giorno
  35: '14.00-14.30', // NY non dovrebbe esserci, ma deve esserci
  40: '14.00-14.30', // Palermo, spedisce con DHL — non allinearlo al 10.30-11.00 degli altri negozi italiani
  48: '14.00-14.30', // London, nessun giorno
  49: '14.00-14.30', // NY Nolita
  5: '10.30-11.00', // Sempione
  50: '10.30-11.00', // Parigi Dragon
  52: '10.30-11.00', // Giovine Italia
  53: '10.30-11.00', // Napoli
  55: '10.30-11.00', // Brescia
  57: '10.30-11.00', // Torino Carlo Alberto
  60: '10.30-11.00', // Campo Marzio 71
  61: '10.30-11.00', // Rinascente Milano
  63: '10.30-11.00', // Bottega Mercato
  64: '14.00-14.30', // Rinascente Roma Fiume Uomo
  80: '14.00-14.30', // Rinascente Roma Fiume Donna
  81: '14.00-14.30', // Rinascente Roma Tritone Uomo
  // 173: // Temporary Tortona
  193: '10.30-11.00', // Roma Prati 95
  206: '10.30-11.00', // Verona Sant'Astasia
  205: '10.30-11.00', // Padova Santa Lucia
  224: '14.00-14.30', // Franciacorta
  229: false, // NY Madison
  237: '14.00-14.30', // Copenhagen
  257: '10.30-11.00', // Forte dei Marmi
  244: '10.30-11.00', // Parigi Boissy
  249: '10.30-11.00', // Parigi Four
  265: '10.30-11.00', // Monaco
}

// Il corriere con cui devono essere ritirati i pacchi
const transferOrderDeliveryShippingCurrier = {
  13: 'NEX, attendo i dettagli per il ritiro', // Roma prati, venerdì
  20: 'NEX, attendo i dettagli per il ritiro', // Torino lunedì
  25: 'NEX, attendo i dettagli per il ritiro', // Campo Marzio 9, giovedì
  26: 'NEX, attendo i dettagli per il ritiro', // Archimede, lunedì
  28: 'NEX, attendo i dettagli per il ritiro', // Garibaldi, giovedì
  29: 'NEX, attendo i dettagli per il ritiro', // Firenze, martedì
  30: 'NEX, attendo i dettagli per il ritiro', // Bologna, mercoledì
  31: 'Transitaladiem, attendo i dettagli per il ritiro', // Parigi, venerdì
  32: 'DHL Economy', // London
  35: 'FedEx', // NY non dovrebbe esserci, ma deve esserci
  40: 'DHL', // Palermo
  48: 'UBV, attendo i dettagli per il ritiro', // London, 'DHL Economy'
  49: '', // NY Nolita
  5: 'NEX, attendo i dettagli per il ritiro', // Sempione, lunedì
  50: 'Transitaladiem, attendo i dettagli per il ritiro', // Parigi Dragon
  52: 'NEX, attendo i dettagli per il ritiro', // Giovine Italia
  53: 'NEX, attendo i dettagli per il ritiro', // Napoli
  55: 'NEX, attendo i dettagli per il ritiro', // Brescia
  57: 'NEX, attendo i dettagli per il ritiro', // Torino Carlo Alberto
  60: 'NEX, attendo i dettagli per il ritiro', // Campo Marzio 71
  61: 'NEX, attendo i dettagli per il ritiro', // Rinascente Milano
  63: 'NEX, attendo i dettagli per il ritiro', // Bottega Mercato
  64: 'SDA, attendo i dettagli per LDV', // Rinascente Roma Fiume Uomo
  80: 'SDA, attendo i dettagli per LDV', // Rinascente Roma Fiume Donna
  81: 'SDA, attendo i dettagli per LDV', // Rinascente Roma Tritone Uomo
  // 173: // Temporary Tortona
  193: 'NEX, attendo i dettagli per il ritiro', // Roma Prati 95
  206: 'NEX, attendo i dettagli per il ritiro', // Verona
  205: 'NEX, attendo i dettagli per il ritiro', // Padova Santa Lucia
  224: 'NEX, attendo i dettagli per il ritiro', // Franciacorta
  229: '', // NY Madison
  237: 'Transitaladiem, attendo i dettagli per il ritiro', // Copenhagen
  257: 'NEX, attendo i dettagli per il ritiro', // Forte dei Marmi
  244: 'Transitaladiem, attendo i dettagli per il ritiro', // Parigi Boissy
  249: 'Transitaladiem, attendo i dettagli per il ritiro', // Parigi Four
  265: 'Transitaladiem, attendo i dettagli per il ritiro', // Monaco
}

// Una nota addizionale per le botteghe abbigliamento
const transferOrderApparelAdditionalCare = {
  13: false, // Roma prati, venerdì
  20: 'Per questo rifornimento ti chiederei di utilizzare colli max 60x40x35', // Torino Mazzini
  25: false, // Campo Marzio 9, giovedì
  26: false, // Archimede, lunedì
  28: false, // Garibaldi, giovedì
  29: "Ti chiederei di gestire i capispalla come appesi e non piegati all'interno dei colli", // Firenze, martedì
  30: false, // Bologna, mercoledì
  31: false, // Parigi, venerdì
  32: false, // London
  35: false, // NY non dovrebbe esserci, ma deve esserci
  40: false, // Palermo
  48: false, // London, 'DHL Economy'
  49: false, // NY Nolita
  5: false, // Sempione, lunedì
  50: false, // Parigi Dragon
  52: "Ti chiederei di gestire i capispalla come appesi e non piegati all'interno dei colli", // Giovine Italia
  53: false, // Napoli
  55: "Ti chiederei di gestire i capispalla come appesi e non piegati all'interno dei colli", // Brescia
  57: 'Per questo rifornimento ti chiederei di utilizzare colli max 60x40x35', // Torino Carlo Alberto
  60: "Ti chiederei di gestire i capispalla come appesi e non piegati all'interno dei colli", // Campo Marzio 71
  61: false, // Rinascente Milano
  63: "Ti chiederei di gestire i capispalla come appesi e non piegati all'interno dei colli", // Bottega Mercato
  64: false, // Rinascente Roma Fiume Uomo
  80: false, // Rinascente Roma Fiume Donna
  81: false, // Rinascente Roma Tritone Uomo
  // 173: // Temporary Tortona
  193: "Ti chiederei di gestire i capispalla come appesi e non piegati all'interno dei colli", // Roma Prati 95
  206: "Ti chiederei di gestire i capispalla come appesi e non piegati all'interno dei colli", // Verona
  205: "Ti chiederei di gestire i capispalla come appesi e non piegati all'interno dei colli", // Padova Santa Lucia
  224: false, // Franciacorta
  229: false, // NY Madison
  237: false, // Copenhagen
  257: `Ti chiederei di gestire i capispalla e i pantaloni come appesi e non piegati all'interno dei colli.`, // Forte dei Marmi
  244: false, // Parigi Boissy
  249: false, // Parigi Four
  265: false, // Monaco
}

const packingListNote = `Stiamo organizzando il ritiro per (data), per cui vi chiederei il dettaglio colli/packing list per (data) (entro le (ore)). E' gestibile?
Ti chiederei di gestire i capispalla piegati all'interno dei colli e non come appesi
Di seguito un paio di note per i documenti:
Per questa spedizione, come per l'ultima volta, avremmo bisogno del packing list dettagliato (collo per collo, sku per sku) e delle dimensioni/peso dei colli una volta pronti.
Gentilmente, ti chiedo anche se è possibile fare la packing list con la progressione dei colli in verticale e non orizzontale.
Per i segnacolli, se possibile vi chiederei di mettere ben in evidenza il numero progressivo (1 di 30, 2 di 30, etc).
Esempio packing list:
Collo 1 di X: n° totale scarpe + elenco delle scarpe inserite (SKU con taglia, tipo 0099420)
Collo 2 di X: n° totale scarpe + elenco delle scarpe inserite (SKU con taglia, tipo 0099430)
Lato nostro non è necessario che i colli siano divisi per stato
Vi chiederei inoltre di cercare di ottimizzare il più possibile le dimensioni dei colli (se possibile utilizzare solo colli 80x40x45)`

// I negozi la cui mail include anche il blocco fisso con la packing list
const transferOrderPackingListNote = {
  48: packingListNote, // London
  49: packingListNote, // NY Nolita
  229: packingListNote, // NY Madison
}

// Gli indirizzi email dei negozi che ricevono la mail da parte di Rifornimenti
const storeEmails = {
  13: 'bottega.roma@velasca.com',
  20: 'bottega.torino@velasca.com',
  25: 'bottega.campomarzio@velasca.com',
  26: 'bottega.archimede@velasca.com',
  28: 'bottega.garibaldi@velasca.com',
  29: 'bottega.firenze@velasca.com',
  30: 'bottega.bologna@velasca.com',
  31: 'bottega.paris@velasca.com',
  32: 'bottega.london@velasca.com', // London
  35: 'bottega.newyork@velasca.com', // NY (OLD) per ora è Francesca, poi andrà cambiato
  40: 'bottega.palermo@velasca.com', // Palermo
  48: 'bottega.london@velasca.com', // London, inglese
  49: 'bottega.newyork@velasca.com', // NY Nolita, inglese
  5: 'bottega.milano@velasca.com', // Sempione
  50: 'bottega.paris@velasca.com', // Parigi Dragon, francese
  52: 'bottega.giovineitalia@velasca.com', // Giovine Italia
  53: 'bottega.napoli@velasca.com', // Napoli
  55: 'bottega.brescia@velasca.com', // Brescia
  57: 'bottega.carloalberto@velasca.com', // Torino Carlo Alberto
  60: 'bottega.campomarzio71@velasca.com', // Campo Marzio 71
  61: 'rinascente.milano.uomo@velasca.com', // Rinascente Milano
  63: 'bottega.viamercato@velasca.com', // Bottega Mercato
  64: 'rinascente.romafiume.uomo@velasca.com', // Rinascente Roma Fiume Uomo
  80: 'rinascente.romafiume.donna@velasca.com', // Rinascente Roma Fiume Donna
  81: 'rinascente.tritone.uomo@velasca.com', // Rinascente Roma Tritone Uomo
  173: 'bottega.vintagetortona@velasca.com', // Temporary Tortona
  193: 'bottega.romatl@velasca.com', // Roma Prati 95
  206: 'bottega.verona@velasca.com',
  205: 'bottega.padova@velasca.com',
  224: 'bottega.franciacorta@velasca.com', // Franciacorta
  229: 'bottega.newyorkmadison@velasca.com', // NY Madison
  237: 'bottega.copenhagen@velasca.com', // Copenhagen
  257: 'bottega.fortedeimarmi@velasca.com', // Forte dei Marmi
  244: 'bottega.parisboissy@velasca.com', // Parigi Boissy
  249: 'bottega.parisruedufour@velasca.com', // Parigi Four
  265: 'bottega.munich@velasca.com', // Monaco
}

// Gli indirizzi email in copia alla mail da parte di Rifornimenti
const storeCCEmails = {
  13: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Roma Prati
  20: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Torino
  25: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Campo Marzio 9
  26: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Archimede
  28: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Garibaldi
  29: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Firenze
  30: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Bologna
  31: 'sarah@transitaladiem.com,alex@transitaladiem.com,mauro@transitaladiem.com,traffico@transitaladiem.com', // Parigi OLD
  32: '', // London (OLD)
  35: '', // NY (OLD)
  40: '', // Palermo
  48: '', // London
  49: 'yazmin@fashionlogistics.com,sandra@fashionlogistics.com', // NY Nolita
  5: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Sempione
  50: 'sarah@transitaladiem.com,alex@transitaladiem.com,mauro@transitaladiem.com,traffico@transitaladiem.com', // Parigi Dragon
  52: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Giovine Italia
  53: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Napoli
  55: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Brescia
  57: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Torino Carlo Alberto
  60: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Campo Marzio 71
  61: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Rinascente Milano
  63: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Bottega Mercato
  64: 'damiano.falleti@velasca.com', // Rinascente Roma Fiume Uomo
  80: 'damiano.falleti@velasca.com', // Rinascente Roma Fiume Donna
  81: 'damiano.falleti@velasca.com', // Rinascente Roma Tritone Uomo
  // 173: // Temporary Tortona
  193: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Roma Prati 95
  206: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com',
  205: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com',
  224: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Franciacorta
  229: 'yazmin@fashionlogistics.com,sandra@fashionlogistics.com', // NY Madison
  237: 'sarah@transitaladiem.com,alex@transitaladiem.com,mauro@transitaladiem.com,traffico@transitaladiem.com,nicholas@transitaladiem.com', // Copenhagen
  257: 'daniela.santorum@nipponexpressitalia.com,cso.italia@nipponexpressitalia.com', // Forte dei Marmi
  244: 'sarah@transitaladiem.com,alex@transitaladiem.com,mauro@transitaladiem.com,traffico@transitaladiem.com', // Parigi Boissy
  249: 'sarah@transitaladiem.com,alex@transitaladiem.com,mauro@transitaladiem.com,traffico@transitaladiem.com', // Parigi Four
  265: 'sarah@transitaladiem.com,alex@transitaladiem.com,mauro@transitaladiem.com,traffico@transitaladiem.com', // Monaco
}

// La lingua dello store presa da Netsuite, per decidere in che lingua viene mandata la mail del notify me.
const storeLanguages = {
  13: '25', // Roma prati, italiano
  20: '25', // Torino italiano
  25: '25', // Campo Marzio 9, italiano
  26: '25', // Archimede, italiano
  28: '25', // Garibaldi, italiano
  29: '25', // Firenze, italiano
  30: '25', // Bologna, italiano
  31: '16', // Parigi (old), francese
  32: '1', // London (old), inglese
  35: '1', // NY (old), inglese
  40: '25', // Palermo italiano
  48: '1', // London, inglese
  49: '1', // NY Nolita, inglese
  5: '25', // Sempione, italiano
  50: '16', // Parigi Dragon, francese
  52: '25', // Giovine italia, italiano
  53: '25', // Napoli, italiano
  55: '25', // Brescia, italiano
  57: '25', // Torino Carlo Alberto, italiano
  60: '25', // Campo Marzio 71
  61: '25', // Rinascente Milano
  63: '25', // Bottega Mercato
  64: '25', // Rinascente Roma Fiume Uomo
  80: '25', // Rinascente Roma Fiume Donna
  81: '25', // Rinascente Roma Tritone Uomo
  173: '25', // Temporary Tortona
  193: '25', // Roma Prati 95
  206: '25', // Verona
  205: '25', // Padova
  257: '25', // Forte dei Marmi, italiano
  244: '16', // Parigi Boissy, francese
  249: '16', // Parigi Four, francese
  265: '18', // Monaco, tedesco
}

export const StoresProvider = ({ children }) => {
  const [stores, setStores] = useState([])
  const warehouseType = useSelector(getFilterValueByKey('warehouseType'))

  const { getTokenSilently } = useAuth0()

  const getStoreName = useCallback(
    id => {
      const store = stores.find(store => parseInt(store.id) === parseInt(id))

      if (store) {
        return store?.values?.name
      }

      const storeWithSublocation = stores.find(store => {
        return store?.values?.sublocations?.find(
          s => parseInt(s.id) === parseInt(id),
        )
      })

      const sublocation = storeWithSublocation?.values?.sublocations.find(
        s => parseInt(s.id) === parseInt(id),
      )

      return sublocation?.values?.name?.split(':')[1] || false
    },
    [stores],
  )

  const getStoreClass = useCallback(
    id => {
      // I need to check the store or the sublocations of the store
      const store = stores.find(
        store =>
          parseInt(store.id) === parseInt(id) ||
          store?.values?.sublocations?.find(
            s => parseInt(s.id) === parseInt(id),
          ),
      )
      return (
        store &&
        store.values &&
        store.values['CUSTRECORD_LOCATION_CLASS.internalid'] &&
        store.values['CUSTRECORD_LOCATION_CLASS.internalid'][0] &&
        store.values['CUSTRECORD_LOCATION_CLASS.internalid'][0].value
      )
    },
    [stores],
  )

  const getStoreSublocations = useCallback(
    id => {
      const store = stores.find(store => parseInt(store.id) === parseInt(id))
      return (store?.values?.sublocations || []).map(s => {
        let sourceWarehouse

        const sublocationName = s.values?.name

        // These are the rules to route SKU transfers. Since FIEGE 02 and FIEGE 03 are not linked
        // to the store 02 and 03 sublocations, we use the warehouse name.
        if (sublocationName.includes('02')) {
          sourceWarehouse = warehouseType === 'fiege' ? '3' : '176'
        } else if (sublocationName.includes('03')) {
          sourceWarehouse = warehouseType === 'fiege' ? '4' : '177'
        }

        return { ...s, sourceWarehouse }
      })
    },
    [stores, warehouseType],
  )

  const isStore = useCallback(
    id => {
      const store = stores.find(store => store.id === id)

      if (store) return true

      return false
    },
    [stores],
  )

  const getSubsidiary = useCallback(
    id => {
      const store = stores.find(store => {
        return (
          parseInt(store.id) === parseInt(id) ||
          store.values.sublocations.find(sublocation => {
            return parseInt(sublocation.id) === parseInt(id)
          }) !== undefined
        )
      })

      return (store && store.values && store.values.subsidiaryId) || false
    },
    [stores],
  )

  useEffect(() => {
    const fn = async () => {
      const token = await getTokenSilently()
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/locations`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(({ data }) => data)
        .catch(() => [])
      setStores(data)
    }

    fn()
  }, [getTokenSilently])

  return (
    <StoresContext.Provider
      value={{
        stores,
        getStoreName,
        getStoreClass,
        getStoreDeliveryDay: id => transferOrderDeliveryDays[id] || false,
        getStoreEmail: id => storeEmails[id],
        getStoreCCEmail: id => storeCCEmails[id],
        getStoreLanguage: id => storeLanguages[id],
        getStoreDeliveryTime: id => transferOrderDeliveryTime[id] || false,
        getStorePickUpDay: id => transferOrderPickUpDays[id] || false,
        getStoreShippingCurrier: id =>
          transferOrderDeliveryShippingCurrier[id] || false,
        getApparelAdditionalCare: id =>
          transferOrderApparelAdditionalCare[id] || false,
        getStorePickUpTime: id => transferOrderPickUpTimes[id] || false,
        getStoreDeliveryNote: id => transferOrderDeliveryNote[id] || false,
        getStorePackingListNote: id =>
          transferOrderPackingListNote[id] || false,
        isStore,
        getSubsidiary,
        getStoreSublocations,
      }}
    >
      {children}
    </StoresContext.Provider>
  )
}
